import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import herophone from "../Images/hero-sec.png";
import { useTranslation } from "react-i18next";

function Hero() {
  const [animated, setAnimated] = useState(false);

  const { t, i18n } = useTranslation();

  useEffect(() => {
    setAnimated(true);
  }, []);


  // const AnimatedText = ({ className }) => {


  

  //   const lines = t("hero_lines", { returnObjects: true });

  //   const container = {
  //     hidden: {},
  //     visible: {
  //       transition: {
  //         staggerChildren: 0.06,
  //       },
  //     },
  //   };

  //   const child = {
  //     hidden: {
  //       y: 100,
  //       opacity: 0,
  //       rotate: 6,
  //     },
  //     visible: {
  //       y: 0,
  //       opacity: 1,
  //       rotate: 0,
  //       transition: {
  //         duration: 0.7,
  //         ease: [0.25, 1, 0.5, 1], 
  //       },
  //     },
  //   };

  //   return (
  //     <motion.div
  //       className={className}
  //       variants={container}
  //       initial={false}
  //       animate="visible"
  //       style={{
  //         display: "flex",
  //         flexDirection: "column",
  //         alignItems: "center",
  //         textAlign: "center",
  //         maxWidth: "750px",
  //         margin: "0 auto",
  //       }}
  //     >
  //       {lines.map((line, lineIndex) => (
  //         <div
  //           key={lineIndex}
  //           style={{
  //             display: "flex",
  //             justifyContent: "center",
  //             gap: "25px",
  //             overflow: "hidden",
  //             flexDirection: i18n.language === "ar" ? "row-reverse" : "row"
  //           }}
  //         >
  //           {line.map((word, index) => (
  //             <span
  //               key={index}
  //               style={{
  //                 overflow: "hidden",
  //                 display: "inline-block",
  //               }}
  //             >
  //               <motion.span
  //                 variants={child}
  //                 style={{ display: "inline-block" }}
  //               >
  //                 {word}
  //               </motion.span>
  //             </span>
  //           ))}
  //         </div>
  //       ))}
  //     </motion.div>
  //   );
  // };
  // const AnimatedText = ({ className }) => {
  //   const lines = t("hero_lines", { returnObjects: true });

  //   const container = {
  //     hidden: {},
  //     visible: {
  //       transition: {
  //         staggerChildren: 0.2,
  //       },
  //     },
  //   };

  //   const child = {
  //     hidden: {
  //       y: 100,
  //       opacity: 0,
  //     },
  //     visible: {
  //       y: 0,
  //       opacity: 1,
  //       transition: {
  //         duration: 0.7,
  //         ease: [0.25, 1, 0.5, 1],
  //       },
  //     },
  //   };

  //   return (
  //     <motion.div
  //       className={className}
  //       variants={container}
  //       initial="hidden"
  //       animate="visible"
  //       style={{
  //         display: "flex",
  //         flexDirection: "column",
  //         alignItems: "center",
  //         textAlign: "center",
  //       }}
  //     >
  //       {lines.map((line, index) => (
  //         <motion.div key={index} variants={child}>
  //           {line}
  //         </motion.div>
  //       ))}
  //     </motion.div>
  //   );
  // };
 
 const SimpleText = ({ className }) => {
  const { t } = useTranslation();
  const text = t("hero_lines");

  return (
    <div className={className} style={{ textAlign: "center" }}>
      {text}
    </div>
  );
};
 
  return (
    <div className="hero-sec-wrapping">
      <div className="container">
        <div className="text-center d-flex justify-content-center hero-heading-wrap flex-column position-relative">

         <SimpleText className="hero-heading" />

 
          <img
            src={herophone}
            className="img-fluid hero-img"
            style={{
              position: "absolute",
              bottom: "-650px",
              left: "50%",
              transform: animated
                ? "translateX(-50%) translateY(0px)"
                : "translateX(-50%) translateY(200px)",
              transition: "transform 0.8s ease-out",
              zIndex: 1,

            }}
          />

        </div>
      </div>
    </div>
  );
}

export default Hero;